import { useMemo } from 'react';

import { ROUTE_TO_VALUES } from 'lib/constants/healthcareProgram/eligibilitySetup';
import { usePractitioners } from 'lib/hooks/queries/practitioners/usePractitioners';

import Badge from 'components/shared/Badge/Badge';
import Select from 'components/shared/Select/Select';
import RadioButton from 'components/shared/RadioButton/RadioButton';

// Route radios for unresolved eligibility. "Alert a team member" reveals a
// practitioner picker for the follow-up task's assignee. "Send to Myriad biller
// queue" is MedBill-only, so it's hidden for non-MedBill practices.
const EligibilityRouteToField = ({ step, onUpdate, isMedbillClient }) => {
  const config = step?.config || {};
  const currentRoute = config.route_to;
  const isTeamMember = !isMedbillClient || currentRoute === ROUTE_TO_VALUES.TEAM_MEMBER;

  const { data: practitionersData, isLoading } = usePractitioners(undefined, {
    enabled: isTeamMember
  });
  const options = practitionersData?.practitionersOptions || [];

  const selectedAssignee = useMemo(
    () => options.find((option) => option.value === config.assignee_id) || null,
    [options, config.assignee_id]
  );

  const setRouteTo = (next) => onUpdate({ config: { ...config, route_to: next } });

  const setAssignee = (option) =>
    onUpdate({ config: { ...config, assignee_id: option?.value ?? null } });

  return (
    <div className="flex flex-col gap-3">
      <RadioButton
        wrapperClassName="w-auto"
        label="Alert a team member"
        value={ROUTE_TO_VALUES.TEAM_MEMBER}
        isSelected={isTeamMember}
        onChange={() => setRouteTo(ROUTE_TO_VALUES.TEAM_MEMBER)}
      />

      {isTeamMember && (
        <div className="ml-5">
          <Select
            isImage
            isClearable
            required
            isLoading={isLoading}
            label="Assign follow-up task to"
            placeholder="Select a team member to notify"
            options={options}
            value={selectedAssignee}
            onChange={setAssignee}
            error={!config.assignee_id ? 'Select a team member to notify' : undefined}
          />
        </div>
      )}

      {isMedbillClient && (
        <div className="flex items-center gap-2">
          <RadioButton
            wrapperClassName="w-auto"
            label="Send to Myriad biller queue"
            value={ROUTE_TO_VALUES.BILLER_QUEUE}
            isSelected={currentRoute === ROUTE_TO_VALUES.BILLER_QUEUE}
            onChange={() => setRouteTo(ROUTE_TO_VALUES.BILLER_QUEUE)}
          />
          <Badge
            text="Recommended"
            color="primary"
            variant="lighter"
            size="small"
            className="px-2"
          />
        </div>
      )}
    </div>
  );
};

export default EligibilityRouteToField;
